module.exports = __webpack_public_path__ + "media/images/shark/Shark2-fd4ea17d53abbac3f22d6da1d448bc7d.png";